import { Box } from '@mui/material';
import { OrgThemedButton } from 'components/OrgThemedButton';
import { endLiveChat } from 'actions/live-chat';
import { useAppDispatch } from 'hooks';

export const SuncoSubmitCsatButton = ({
  csatLink,
  csatText,
}: {
  csatLink: string;
  csatText?: string;
}) => {
  const dispatch = useAppDispatch();

  return (
    <Box mb='16px' ml='32px' mt='-8px'>
      <OrgThemedButton
        component='a'
        href={csatLink}
        onClick={() => {
          dispatch(endLiveChat());
        }}
        rel='noopener'
        target='_blank'
        variant='contained'
      >
        {csatText || 'Submit rating'}
      </OrgThemedButton>
    </Box>
  );
};
